import type { AllowedProductProfileDto } from "../../types/AllowedProductProfileDto";
import type { AllowedProductProfileEntity } from "../../types/AllowedProductProfileEntity";

export const AllowedProductProfileDtoToEntity = ({ ...rest }: Readonly<AllowedProductProfileDto>): AllowedProductProfileEntity => {
    return { ...rest };
};
